import React from 'react';
import Image from 'Nori/Image';
import styles from 'Custom/Hero/index.module.scss';
import ItemBreakpoint from 'Custom/ItemBreakpoint/index';

const HERO_VARIANTS = {
  overlap: styles.overlap,
  cover: styles.cover,
  main: styles.main,
  mainSpanish: styles.mainSpanish,
  default: styles.cover,
};

const HERO_BACKGROUND = {
  primaryLight: styles.primaryLight,
  secondary2Light: styles.secondary2Light,
  secondary4Light: styles.secondary4Light,
  noBackground: styles.noBackground,
  default: styles.noBackground,
};

const HeroImage = ({ image = null, caption = '', ...props }) => {
  return (
    image && (
      <figure className={styles.heroImage} {...props}>
        <Image alt="" {...image} />
        {caption && <figcaption>{caption}</figcaption>}
      </figure>
    )
  );
};

const Hero = ({
  className = '',
  background = '',
  backgroundImage = '',
  mobileBackgroundImage = '',
  caption = '',
  title = '',
  variant = '',
  image = null,
  mobileImage = null,
  imageBreakpoint = 'lg',
  autoHeightOnMobile = false,
  children,
  ...props
}) => {
  const backgroundClassName =
    HERO_BACKGROUND[background] || HERO_BACKGROUND.default;
  const variantClassName = HERO_VARIANTS[variant] || HERO_VARIANTS.default;
  const autoHeightOnMobileClassName = autoHeightOnMobile
    ? styles.autoHeightOnMobile
    : '';
  // Dynamic background image style with responsive support
  const backgroundStyle = {};
  const hasCustomBackground = backgroundImage || mobileBackgroundImage;

  if (backgroundImage) {
    backgroundStyle['--desktop-bg'] = `url(${backgroundImage})`;
  }

  if (mobileBackgroundImage) {
    backgroundStyle['--mobile-bg'] = `url(${mobileBackgroundImage})`;
  }

  const customBackgroundClass = hasCustomBackground ? styles.customBackground : '';

  return (
    <div
      className={`${styles.hero} ${backgroundClassName} ${variantClassName} ${autoHeightOnMobileClassName} ${customBackgroundClass} ${className}`}
      style={backgroundStyle}
      {...props}
    >
      <div className={styles.heroLeft}>
        <div className={styles.heroContent}>
          {title && <h1 className={styles.heroMainTitle}>{title}</h1>}
          <div className={styles.heroChildren}>{children}</div>
        </div>
      </div>
      {image && (
        <div className={styles.heroRight}>
          {mobileImage ? (
            <ItemBreakpoint breakpoint={imageBreakpoint}>
              <HeroImage image={image} caption={caption} />
              <HeroImage image={mobileImage} caption={caption} />
            </ItemBreakpoint>
          ) : (
            <HeroImage image={image} caption={caption} />
          )}
        </div>
      )}
    </div>
  );
};

export default Hero;
